var auth = require('./auth');

var client = require('./client');

var codecs = require('./codecs');

var document = require('./document');

var errors = require('./errors');

var transports = require('./transports');

var utils = require('./utils');

var coreapi = {
  Client: client.Client,
  Document: document.Document,
  Link: document.Link,
  auth: auth,
  codecs: codecs,
  errors: errors,
  transports: transports,
  utils: utils
};
module.exports = coreapi;